import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom'
import Sidebar from './Sidebar';
import Dashboard from './Dashboard';
import ManageLicences from './ManageLicences';
import ManageUsers from './ManageUsers';
import UploadUpdate from './UploadUpdate';
import MonitorLicenses from './MonitorLicenses';
import './Sidebar.css';
import AuthService from './auth/AuthServices';
import SecureLS from 'secure-ls'
import { useNavigate, Navigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();
  const ls = new SecureLS({encodingType: 'aes'})
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkJWTToken = async () => {
      try {
        const token = ls.get('jwtToken'); // Get raw token value
        if (!token) {
          throw new Error('Token not found'); // Trigger redirection if no token
        }

        const response = await AuthService.auth_me();
        if (response.status === 200 || response.status === 201) {
          setIsAuthenticated(true); // Set authenticated state
        } else {
          throw new Error('Invalid token'); // Trigger redirection if the token is invalid
        }
      } catch (error) {
        console.error('Authentication failed:', error);
        setIsAuthenticated(false); // Set unauthenticated state
        navigate('/auth'); // Redirect on error
      }
    };
  
    checkJWTToken();
  }, [navigate]); // Ensure `navigate` is included as a dependency

  if (isAuthenticated === null) {
    // While checking authentication, show a loading spinner or blank screen
    return <div>Loading...</div>;
  }
  
  return (
      <div style={{ display: 'flex' }}>
          {/* Sidebar */}
          <Sidebar />
          {/* Main Content Area */}
          <div className="content">
              <Routes>
                  <Route path="/" element={<Navigate to="/home/dashboard" replace />} />
                  <Route path="Dashboard" element={<Dashboard />} />
                  <Route path="ManageUsers" element={<ManageUsers />} />
                  <Route path="ManageLicences" element={<ManageLicences />} />
                  <Route path="MonitorLicenses" element={<MonitorLicenses />} />
                  <Route path="UploadUpdate" element={<UploadUpdate />} />
              </Routes>
          </div>
      </div>
  );
};

export default HomePage;

